const requireModule = require.context('.', true, /\.\/[\w-_]+\/$/)

const modules = {}

requireModule.keys().forEach(fileName => {
  if (fileName === './') return

  const path = fileName.replace(/(\.\/|\.js)/g, '')
  const [moduleName] = path.split('/')

  modules[moduleName] = requireModule(fileName).default
})

export default modules
